import { ChevronDown } from 'lucide-react';
import { MutableRefObject, ReactNode, SyntheticEvent, useRef, useState } from 'react';

import { clsx } from 'clsx';

import { ICON_DEFAULT } from '@shared/constants/colors';

import cls from './FilterWrapper.module.scss';

export type FilterWrapperVariantType = 'switch' | 'range' | 'checkbox-list' | 'radio-list';

export type FilterWrapperProps = {
  label: string;
  children: ReactNode;
  className?: string;
  variant: FilterWrapperVariantType;
  onCloseCallBack?: () => void;
  isActiveFilter?: boolean;
  resetActiveFilter?: () => void;
};

export const FilterWrapper = ({
  label,
  children,
  className,
  variant,
  onCloseCallBack,
  isActiveFilter,
  resetActiveFilter
}: FilterWrapperProps) => {
  const ref = useRef() as MutableRefObject<HTMLDivElement>;
  const [open, setOpen] = useState(false);

  const isList = variant === 'checkbox-list' || variant === 'radio-list';

  const toggleFilter = () => {
    if (!isList) return;

    if (open) {
      setOpen(false);
      ref.current.style.maxHeight = '0';

      setTimeout(() => {
        if (onCloseCallBack) onCloseCallBack();
      }, 125);
    } else {
      setOpen(true);
      ref.current.style.maxHeight = ref.current.scrollHeight + 'px';
    }
  };

  const onResetActiveFilterHandler = (e: SyntheticEvent) => {
    e.stopPropagation();
    if (resetActiveFilter) resetActiveFilter();
  };

  const mods: Record<string, string | boolean | undefined> = {
    [cls.switch]: variant === 'switch',
    [cls.range]: variant === 'range',
    [cls.list]: isList,
    [cls.open]: open
  };

  return (
    <div
      data-testid={'filter-wrapper'}
      className={clsx(cls.wrap, className, mods)}
    >
      <div
        data-testid={'filter-wrapper-trigger'}
        onClick={toggleFilter}
        className={cls.label}
      >
        <span>{label}</span>
        {isActiveFilter && (
          <div className={cls.activeFilter}>
            <div className={cls.circle}></div>
            <button
              data-testid={'filter-wrapper-reset-btn'}
              onClick={onResetActiveFilterHandler}
              className={cls.resetButton}
            >
              Сбросить
            </button>
          </div>
        )}

        {isList && (
          <button className={cls.trigger}>
            <ChevronDown
              size={24}
              color={ICON_DEFAULT}
            />
          </button>
        )}
      </div>
      <div
        ref={ref}
        data-testid={'filter-wrapper-children'}
        className={cls.content}
      >
        {children}
      </div>
    </div>
  );
};
